import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */

import { Popover } from '@wordpress/components';
/**
 * Internal dependencies
 */

import BlockFormatControls from '../block-format-controls';
import FormatToolbar from './format-toolbar';

function _getAnchorRect(anchorObj) {
  var current = anchorObj.current;
  var rect = current.getBoundingClientRect(); // Add some space.

  var buffer = 6; // Subtract padding if any.

  var _window$getComputedSt = window.getComputedStyle(current),
      paddingTop = _window$getComputedSt.paddingTop;

  paddingTop = parseInt(paddingTop, 10);
  return {
    x: rect.left,
    y: rect.top + paddingTop - buffer,
    width: rect.width,
    height: rect.height - paddingTop + buffer,
    left: rect.left,
    right: rect.right,
    top: rect.top + paddingTop - buffer,
    bottom: rect.bottom
  };
}

var FormatToolbarContainer = function FormatToolbarContainer(_ref) {
  var inline = _ref.inline,
      anchorObj = _ref.anchorObj;

  if (inline) {
    // Render in popover
    return createElement(Popover, {
      noArrow: true,
      position: "top center",
      focusOnMount: false,
      getAnchorRect: function getAnchorRect() {
        return _getAnchorRect(anchorObj);
      },
      className: "block-editor-rich-text__inline-format-toolbar"
    }, createElement(FormatToolbar, null));
  } // Render regular toolbar


  return createElement(BlockFormatControls, null, createElement(FormatToolbar, null));
};

export default FormatToolbarContainer;